import React, { useState } from "react";
import styles from "./index.module.scss";
import nextArrow from "../../assets/images/nextArrow.png";
import { stepsModules } from "../../steps";
import { useSelector } from "react-redux";
import downloadPng from "../../assets/images/download.png";
import moment from "moment";
import { utils, writeFile } from "xlsx";

const extraDetailsKeys = [
  "SNo.",
  "Activity Name",
  "Completed",
  "Score",
  "Sequence Attempted",
];

const UserDetails = ({ stepsList }) => {
  const [showExtraDetails, setShowExtraDetails] = useState(null);
  const currentUser = useSelector((state) => state.details.currentUser);

  const handleShowExtraDetails = (ind) => {
    setShowExtraDetails((prev) => (prev === ind ? null : ind));
  };

  const handleDownload = () => {
    let aoo = [];

    stepsList?.forEach((step) => {
      let _filteredArr = step.task?.filter((t) => t.inorderIndex === -1) || [];

      let _newArr =
        step.task
          ?.filter((t) => t.inorderIndex !== -1)
          .sort((a, b) => b.inorderIndex - a.inorderIndex) || [];

      let taskArr = [..._newArr, ..._filteredArr];

      aoo.push({
        "Module Name": stepsModules[step.id].name,
        "Step Name": "",
        score: step.totalPoints,
        "Minutes Spent": moment.utc(step.timespent * 1000).format("mm:ss"),
      });

      taskArr.forEach((details) => {
        aoo.push({
          "Module Name": stepsModules[step.id].name,
          "Step Name": stepsModules[step.id].tasks[details.taskid]?.name,
          score: details.score,
          "Minutes Spent": "",
        });
      });
    });

    const workbook = utils.book_new();
    const worksheet = utils.json_to_sheet(aoo);
    utils.book_append_sheet(workbook, worksheet, "Sheet1");
    writeFile(workbook, "userDetails.xlsx");
  };

  return (
    <div className={styles.userDetailsWrapper}>
      <div className={styles.list}>
        {/* HEADER */}
        <div className={styles.subHeader}>
          <div className={styles.userName}>{currentUser?.first_name}</div>

          <div className={styles.labelWrapper}>
            <div className={styles.downloadBtn} onClick={handleDownload}>
              <span className={styles.downloadText}>Download Reports</span>
              <img src={downloadPng} />
            </div>
          </div>
        </div>

        <div className={`${styles.subHeader} ${styles.secondary}`}>
          <div className={styles.labelWrapper}>
            <div className={styles.label}>
              <div>Total score</div>
              <div>Minutes Spent</div>
            </div>
          </div>
        </div>

        {/* MODULE LIST */}
        {stepsList?.length ? (
          stepsList.map((item, index) => {
            // DO NOT REMOVE THIS COMMENTED CODE
            // let ordered =
            //   item.task
            //     ?.filter((t) => t.inorderIndex !== -1)
            //     .sort((a, b) => a.inorderIndex - b.inorderIndex) || [];

            // let unordered =
            //   item.task?.filter((t) => t.inorderIndex === -1) || [];

            return (
              <React.Fragment key={index}>
                {/* MODULE CARD */}
                <div
                  className={styles.itemWrapper}
                  onClick={() => handleShowExtraDetails(index)}
                >
                  <div className={styles.itemName}>
                    <div
                      className={`${styles.dropdownIcon} ${
                        showExtraDetails === index ? styles.open : ""
                      }`}
                    >
                      <img src={nextArrow} />
                    </div>
                    <span className={styles.itemNameText}>
                      {stepsModules[item.id].name}
                    </span>
                  </div>

                  <div className={styles.label}>
                    <div data-label="Total score">
                      {item.totalPoints}/{item.task.length}
                    </div>
                    <div data-label="Minutes Spent">
                      {moment.utc(item.timespent * 1000).format("mm:ss")}
                    </div>
                  </div>
                </div>

                {/* EXTRA DETAILS */}
                {showExtraDetails === index && (
                  <div className={styles.extraDetailWrapper}>
                    <div className={styles.tableScroll}>
                      <table className={styles.extraDetails}>
                        <tr>
                          {extraDetailsKeys.map((key) => (
                            <td key={key}>{key}</td>
                          ))}
                        </tr>

                        {item.task.map((details, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                              {
                                stepsModules[item.id].tasks[details.taskid]
                                  ?.name
                              }
                            </td>
                            <td
                              style={{
                                color: details.completed
                                  ? "#21C507"
                                  : "#FF0000",
                                fontWeight: 600,
                              }}
                            >
                              {details.completed ? "Yes" : "No"}
                            </td>
                            <td>{details.score}</td>
                            <td
                              style={{
                                color: details.inorder ? "#21C507" : "#FF0000",
                                fontWeight: 600,
                              }}
                            >
                              {details.inorder ? "Yes" : "No"}{" "}
                              {details.inorderIndex !== -1 && (
                                <span style={{ color: "gray" }}>
                                  ({details.inorderIndex + 1})
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </table>
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })
        ) : (
          <div className={styles.noTask}>No Tasks Added</div>
        )}
      </div>
    </div>
  );
};

export default UserDetails;
